export interface IProgressBarState {
  percentageOfEventsCompleted: number;
  numberOfSuccessfulEvents: number;
  progressBarType: string;
  totalNumberOfEvents: number;
}

export class ProgressBarState implements IProgressBarState {
  percentageOfEventsCompleted: number;
  numberOfSuccessfulEvents: number;
  progressBarType: string;
  public totalNumberOfEvents: number;

  constructor() {
    this.percentageOfEventsCompleted = 0;
    this.numberOfSuccessfulEvents = 0;
    this.progressBarType = "success";
    this.totalNumberOfEvents = 0;
  }
}
